import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const reportModule = () => import('./report.module').then((m) => m.ReportModule);

export const reportRoutes: Routes = [
  {
    path: 'report',
    canActivateChild: [RoleGuard],
    loadChildren: reportModule,
    data: {
      enum: 'REPORT',
      label: 'Report',
      icon: 'ic_task.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'LIST_NEED_FULLFILL',
          label: 'Need Fullfill Item',
          path: 'report/need-fullfill',
          children: [],
        },
      ],
    },
  },
];
